import { cn } from 'corso-admin-ui';
import { ReactNode } from 'react';
import { useIsCorsoCxAgent } from '~/hooks/useIsCorsoAdmin';
import { ShippingClaimAlerts } from './components/ShippingClaimAlerts';
import { ShippingClaimCustomerDetail } from './components/ShippingClaimCustomerDetail';
import { ShippingClaimLineItemList } from './components/ShippingClaimLineItemList';
import { ShippingClaimMessages } from './components/ShippingClaimMessages';
import { ShippingClaimOrderDisplay } from './components/ShippingClaimOrderDisplay';
import { ShippingClaimPage } from './components/ShippingClaimPage';
import { ShippingClaimRemovedLineItems } from './components/ShippingClaimRemovedLineItems';
import { ShippingClaimRequest } from './components/ShippingClaimRequest';
import { ShippingClaimRiskAssessment } from './components/ShippingClaimRiskAssessment';
import { ShippingClaimTagDisplay } from './components/ShippingClaimTagDisplay';
import { ShippingClaimTimeline } from './components/ShippingClaimTimeline';
import { ShippingClaimReviewProvider } from './ShippingClaimReviewProvider';

// below `md` the columns use `display: contents`, so blocks share one flex column and `mobileOrder` reorders them for CX agents
function Block({
  mobileOrderStyles,
  children,
}: {
  mobileOrderStyles: string;
  children: ReactNode;
}) {
  const isCorsoCxAgent = useIsCorsoCxAgent();
  return (
    <div
      className={cn(
        'space-y-4 empty:hidden',
        isCorsoCxAgent && mobileOrderStyles,
      )}
    >
      {children}
    </div>
  );
}

export default function ShippingClaimReviewPage() {
  return (
    <ShippingClaimReviewProvider>
      <ShippingClaimPage>
        <ShippingClaimAlerts />

        {/* be cautious when changing the structure of the grid and blocks as mobile and desktop have different orderings */}
        <div className="flex flex-col gap-4 md:grid md:grid-cols-[3fr_1fr]">
          <div className="contents md:block md:space-y-4">
            <Block mobileOrderStyles="max-md:order-1">
              <ShippingClaimRequest />
            </Block>
            <Block mobileOrderStyles="max-md:order-4">
              <ShippingClaimLineItemList />
            </Block>
            <Block mobileOrderStyles="max-md:order-5">
              <ShippingClaimRemovedLineItems />
            </Block>
            <Block mobileOrderStyles="max-md:order-8">
              <ShippingClaimTimeline />
            </Block>
            <Block mobileOrderStyles="max-md:order-7">
              <ShippingClaimMessages />
            </Block>
          </div>
          <div className="contents md:block md:space-y-4">
            <Block mobileOrderStyles="max-md:order-2">
              <ShippingClaimOrderDisplay />
            </Block>
            <Block mobileOrderStyles="max-md:order-9">
              <ShippingClaimRiskAssessment />
            </Block>
            <Block mobileOrderStyles="max-md:order-6">
              <ShippingClaimTagDisplay />
            </Block>
            <Block mobileOrderStyles="max-md:order-3">
              <ShippingClaimCustomerDetail />
            </Block>
          </div>
        </div>
      </ShippingClaimPage>
    </ShippingClaimReviewProvider>
  );
}
